import React, { useState } from 'react';
import MailingAddressForm from './MailingAddressForm';
import ExpandableFormList from "../gdk/ExpandableForm/ExpandableFormList";
import ExpandableFormListItem from "../gdk/ExpandableForm/ExpandableFormListItem";

export default function AgencyDetails({
    agencyProfile = {},
    setAgencyProfile = () => { },
    onSave,
    onCancel,
}) {


    const [isEditing, setIsEditing] = useState(false);
    const [mailingAddressExpandableForm, setMailingAddressExpandableForm] = useState();

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleSave = (updatedAgencyProfile) => {
        setIsEditing(false);
        onSave(updatedAgencyProfile);
    };

    const handleCancel = () => {
        setIsEditing(false);
        onCancel();
    };


    return (
        <li>
            <div className="accordion-headline">
                <span className="geico-icon geico-icon--actionable icon-business-ins"></span>
                <div className="accordion-headline-content-wrapper">
                    <div className="accordion-left-content-wrapper">
                        <div className="heading h4">{agencyProfile.name}</div>
                    </div>
                </div>
            </div>
            <div className="accordion-content-container">
                <div className="accordion-content container">
                    <ul className="list list--two-column">
                        <li>
                            <div>Agency ID</div>
                            <div>{agencyProfile.agencyId}</div>
                        </li>
                        <li>
                            <div>Affiliated Agency Group</div>
                            <div>{agencyProfile.affiliatedAgencyGroup}</div>
                        </li>
                        <li>
                            <div>Date Appointed with GEICO</div>
                            <div>{agencyProfile.dateAppointed}</div>
                        </li>
                        <li>
                            <div>Appointed Lines of Business</div>
                            <div>{agencyProfile.appointedLinesOfBusiness}</div>
                        </li>
                        <li>
                            <div>Appointed States</div>
                            <div>{agencyProfile.appointedStates}</div>
                        </li>
                        <li>
                            <div>Licensed States</div>
                            <div>{agencyProfile.licensedStates ? agencyProfile.licensedStates.join(', ') : ''}</div>
                        </li>
                        <li>
                            <div>Business Address</div>
                            <div>{AddressString(agencyProfile.businessAddress)}</div>
                        </li>
                        <li>
                            <div>Mailing Address</div>
                            {isEditing ? (
                                <ExpandableFormList setExpandableForm={setMailingAddressExpandableForm}>
                                    <ExpandableFormListItem
                                        id="mailing-address-form-li"
                                        headline="Mailing Address"
                                        editable={false}
                                        form={<MailingAddressForm
                                            onSave={handleSave}
                                            onCancel={handleCancel}
                                            expandableForm={mailingAddressExpandableForm}
                                            agencyProfile={agencyProfile}
                                            setAgencyProfile={setAgencyProfile}
                                        />}
                                    />
                                </ExpandableFormList>
                            ) : (
                                <div>
                                    <div>{AddressString(agencyProfile.mailingAddress)}</div>
                                    <div className="right-side">
                                        <button
                                            type="button"
                                            className="expandable-form-control expandable-form-edit-icon geico-icon--small geico-icon--actionable geico-icon icon-edit"
                                            onClick={handleEditClick}
                                            aria-label="Edit mailing address"
                                            title="Edit mailing address"
                                        ></button>
                                    </div>
                                </div>
                            )}
                        </li>
                        <li>
                            <div>Principal Agent</div>
                            <div>{agencyProfile.principalAgent}</div>
                        </li>
                        <li>
                            <div>Principal Business Phone</div>
                            <div>{agencyProfile.principalBusinessPhone}</div>
                        </li>
                        <li>
                            <div>Principal Email</div>
                            <div>{agencyProfile.principalEmail}</div>
                        </li>
                        {
                            agencyProfile.bankingExists === null || agencyProfile.bankingExists === undefined ? null :
                                <li>
                                    <div>Banking Details</div>
                                    <div>{agencyProfile.bankingExists ? "Yes" : "No"}</div>
                                </li>
                        }
                    </ul>
                </div>
            </div>
        </li>
    );
};

const AddressString = (a) => a ? `${a.street1} ${a.city}, ${a.state}, ${a.zipCode}` : "";
